<template>
    <div>
        <template v-if="subscription_fee == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Subscription Fee </h1>
            </div>
            <div class="global-main">
                <form id="subscriptionFeeForm" @submit.prevent="addSubscriptionFeeData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Company </label>
                            <select v-model="form.company_id" data-live-search="true" name="company_id" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null" >
                                <option value="" selected>Select Company</option>
                                <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">{{ company.name }}</option>
                            </select>
                            <has-error :form="form" field="companyId"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Charges </label>
                            <input v-model="form.charges" type="text" name="charges" class="form-control" :class="{ 'is-invalid': form.errors.has('charges') }">
                            <has-error :form="form" field="charges"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Status </label>
                            <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="" selected>Select Status</option>
                                <option value="ON">ON</option>
                                <option value="OFF">OFF</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/subscriptionFee" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="subscription_fee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="subscription_fee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    company_id: "",
                  charges: "2500",
                    status: "ON",
                }),
                companies: {},
              subscription_fee: null,
            };
        },
        methods: {
            addSubscriptionFeeData() {
                this.$Progress.start();
                this.form
                    .post("api/addSubscriptionFee")
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.data.code == 200) {
                                this.resetForm();
                                this.$Progress.finish();
                                this.showToastBox("success", "Subscription Fee added successfully");
                                this.$router.push("/subscriptionFee");
                            } else {
                                this.showToastBox("error", res.data.message);
                            }
                        } else {
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                        }
                    }).then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        const errorMessages = Object.entries(err.response.data.errors)
                            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                            .join('\n');
                        this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    });
            },
            resetForm() {
                this.form.companyId = "";
                this.form.charges = "";
                this.form.status = "";
            },
            getSubscriptionFeeData() {
                axios
                    .get("/api/transactionFeeData")
                    .then((res) => {
                        this.companies = res.data;
                    })
                    .then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        console.log(err);
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("subscription_fee")
                .then((result) => {
                    this.subscription_fee = result.subscription_fee;
                })
                .then((result) => {
                    if (this.subscription_fee == true) {
                        this.getSubscriptionFeeData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
